import React, { useContext } from 'react'
import { TooltipContext } from '../Tooltip'
import { renderChildren } from '../children'
import { PROP_TYPE_CHILDREN } from '../constants'

const TooltipToggle = ({
  children,
}: {
  children:
    | React.ReactElement
    | React.ReactElement[]
    | React.ReactText
    | boolean
    | null
    | undefined
}): JSX.Element => {
  const { hideTooltip, showTooltip, setToggleElement } =
    useContext(TooltipContext)
  return renderChildren(children, {
    onMouseOver: showTooltip,
    onMouseOut: hideTooltip,
    onFocus: showTooltip,
    onBlur: hideTooltip,
    ref: setToggleElement,
  }) as JSX.Element
}

TooltipToggle.propTypes = {
  children: PROP_TYPE_CHILDREN,
}

export default TooltipToggle
